/** Civil days beginning with today in the professional's timezone.
 *
 * Convert the current instant only once. Adding fixed 24-hour offsets to an
 * instant before formatting repeats or skips a date near midnight when a DST
 * offset changes. Subsequent increments are civil UTC dates, not instants in
 * the professional's timezone, so every YYYY-MM-DD appears exactly once.
 */
export function upcomingDays(timeZone: string, count: number, now = new Date()): string[] {
  const today = new Intl.DateTimeFormat("en-CA", {
    timeZone, year: "numeric", month: "2-digit", day: "2-digit",
  }).format(now);
  const start = Date.parse(`${today}T12:00:00.000Z`);
  return Array.from({ length: count }, (_, offset) =>
    new Date(start + offset * 86_400_000).toISOString().slice(0, 10)
  );
}
